import { Controller } from 'stimulus';
import SwiperCore, { Navigation } from 'swiper';

class SliderController extends Controller {
  connect() {
    SwiperCore.use([Navigation]);

    this.swiper = new SwiperCore(this.element, {
      loop: true,
      grabCursor: true,
      spaceBetween: 20,
      centeredSlides: true,

      navigation: {
        prevEl: this.hasPrevTarget ? this.prevTarget : null,
        nextEl: this.hasNextTarget ? this.nextTarget : null,
      },

      breakpoints: {
        768: {
          spaceBetween: 40,
          slidesPerView: 3,
        },
        992: {
          spaceBetween: 40,
          slidesPerView: 3,
        },
        1200: {
          spaceBetween: 90,
          slidesPerView: 3,
        },
      },
    });
  }
}

SliderController.targets = [
  'prev',
  'next',
];

export default SliderController;
